import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { AiConfigModule } from '../ai-dashboard/ai-config/ai-config.module';
import { SuscripcionesController } from './suscripciones.controller';
import { SuscripcionesCronService } from './suscripciones.cron';
import { SuscripcionesService } from './suscripciones.service';

@Module({
  imports: [AiConfigModule],
  controllers: [SuscripcionesController],
  providers: [SuscripcionesService, SuscripcionesCronService],
  exports: [SuscripcionesService],
})
export class SuscripcionesModule {}
